import React from "react";
import { useStockStatisticModel } from "../stockStatisticModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { IShelfFileds, warehouseService } from "../../../base/warehouse/warehouseService"
import { useDictModel } from "../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { searchParam, shelfList, updateSearchParam, resetSearchParam, loadData } = useStockStatisticModel();
    const { warehouseList } = useGlobalModel();
    const { getSelectedDictOne } = useDictModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "商品编码",
            placeholder: Locale["Material Code"],
            fieldName: "materialCode"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "商品名称",
            placeholder: Locale["Material Name"],
            fieldName: "materialName"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "配件品牌",
            placeholder: Locale["Accessories brand"],
            fieldName: "brandCode",
            options: getSelectedDictOne(DictCodeEnmu.MATERIAL_BRAND)
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "所属库房",
            placeholder: Locale["Warehouse Management"],
            fieldName: "warehouseCode",
            options: transOptions(warehouseList)
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "所属货位",
            placeholder: Locale["Shelf"],
            fieldName: "shelfCode",
            // showSearch:true,
            // options:transOptions(shelfList as IShelfFileds[])
        },
        {
            type: SearchTypeEnum.CheckBox,
            // placeholder: "只显示有货",
            placeholder: Locale["Only show available"],
            fieldName: "age",
        },
    ]
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Warehouse Management"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Inventory Statistics"]}</span>
    </>
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}